import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { ArrowRight, Flame } from "lucide-react";

export default function WeekendPromoStrip() {
  const { t } = useApp();
  const [pools, setPools] = useState([]);
  useEffect(() => { api.get("/pools/promos/featured").then((r) => setPools(r.data)).catch(() => {}); }, []);
  if (!pools.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 py-12">
      <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-[#E27B58] to-[#C56A4A] text-white p-8 lg:p-12">
        <div className="flex items-start justify-between mb-6 flex-wrap gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2"><Flame className="w-5 h-5" /><span className="overline">{t("promo.badge")}</span></div>
            <h2 className="font-display text-3xl lg:text-4xl font-bold leading-tight">{t("promo.title")}</h2>
            <p className="text-white/85 mt-2 max-w-lg text-sm">{t("promo.subtitle")}</p>
          </div>
          <Link to="/search" className="inline-flex items-center gap-2 bg-white text-[#005C7A] px-5 py-2.5 rounded-full font-semibold hover:bg-white/90 transition self-end" data-testid="promo-see-all">
            {t("promo.seeAll")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="flex gap-4 overflow-x-auto pb-2 snap-x -mx-2 px-2">
          {pools.map((p) => {
            const finalPrice = +(p.price_per_day * (1 - p.discount_pct)).toFixed(2);
            return (
              <Link key={p.pool_id} to={`/pool/${p.pool_id}`} className="shrink-0 w-[260px] bg-white text-[#1A202C] rounded-2xl overflow-hidden snap-start hover:-translate-y-1 transition" data-testid={`promo-${p.pool_id}`}>
                <div className="relative aspect-[4/3] bg-muted">
                  <img src={p.photos?.[0] ? fileUrl(p.photos[0]) : "https://images.unsplash.com/photo-1582533568805-78a15dcb01b5?w=600"} alt={p.title} className="w-full h-full object-cover" />
                  <div className="absolute top-3 left-3 bg-[#E27B58] text-white px-2.5 py-1 rounded-full text-xs font-bold">−{Math.round(p.discount_pct * 100)}%</div>
                </div>
                <div className="p-4">
                  <div className="font-display font-semibold truncate">{p.title}</div>
                  <div className="text-xs text-muted-foreground mb-2">{p.city}</div>
                  <div className="text-sm">
                    <span className="line-through text-muted-foreground mr-1">€{p.price_per_day}</span>
                    <span className="font-bold text-[#005C7A]">€{finalPrice}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
